import React, { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import expandPanel from "../../assests/images/expand_panel.png";
import ClosePanel from "../../assests/images/close_panel.png";
import DummyImg from "../../assests/images/anagrafiche.png";
import { useDispatch } from "react-redux";
import { onCommonReducerUpdate } from "../../service/action/actioncreator/CommonAction/Common";
import { SIDEBARVIEW } from "../../service/action/actiontype/CommonType/CommonType";
import { Tooltip } from "primereact/tooltip";
import { useTranslation } from "react-i18next";
import FooterComponent from "../../screens/pages/FooterComponent";

const SideMenu = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(true);
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [activeParentKey, setActiveParentKey] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const sidebarValue = useSelector(
    (state) => state.commonReducer.isSidebarView
  );
  const sideMenuData = localStorage.getItem("sideMenu");
  const location = useLocation();
  const { t } = useTranslation("translation");

  const handleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
    dispatch(onCommonReducerUpdate(isSidebarCollapsed, SIDEBARVIEW));
  };
  const toggleExpand = (key) => {
    setExpandedKeys((prevState) => {
      if (prevState.includes(key)) {
        return prevState.filter((item) => item !== key);
      } else {
        return [...prevState, key];
      }
    });
  };

  const renderMenuItems = (items) => {
    return items?.map((item, index) => {
      const isParent = item.items && item.items.length > 0;
      const isExpanded = expandedKeys.includes(index);
      const isActive = location.pathname.split("/")[1] === item.pageUrl;
      return (
        <li
          key={index}
          className={`menu-item ${isParent && isExpanded ? "expanded" : ""} ${
            isActive ? "active-item" : ""
          } mt-2`}
        >
          <Link
            to={item.pageUrl}
            onClick={(e) => {
              if (isParent) {
                e.preventDefault();
                toggleExpand(index);
              }
            }}
            className={`menu-link ${isActive ? "active-link" : ""}`}
          >
            {item?.menuIcon && (
              <span
                className="menu-icon"
                id={`tooltip-icon-${index}`}
                style={{ margin: 0 }}
              >
                <img
                  className={`sidebar-img menu-icon-${index} ${
                    t(item.pageName) !== "Chat" ? "img-color" : "chat-img"
                  }`}
                  src={
                    item.menuIcon === "string"
                      ? DummyImg
                      : `${process.env.REACT_APP_IMAGE_URL + item?.menuIcon}`
                  }
                  alt={t(item.pageName)}
                />
                {sidebarValue && (
                  <Tooltip target={`#tooltip-icon-${index}`} position="right">
                    {t(item.pageName)}
                  </Tooltip>
                )}
              </span>
            )}
            {!sidebarValue && (
              <span className="menu-label ms-2">{t(item.pageName)}</span>
            )}
          </Link>
          {isParent && isExpanded && (
            <>
              <div
                className=""
                style={
                  isParent && isExpanded
                    ? { borderBottom: "1px solid rgb(235, 233, 226)" }
                    : {}
                }
              ></div>
              <ul
                className="child-menu"
                style={{
                  marginLeft: "18%",
                }}
              >
                {renderMenuItems(item.items)}
              </ul>
            </>
          )}
        </li>
      );
    });
  };
  return (
    <div className={`layout`}>
      <div className={`sidebar ${sidebarValue ? "collapsed" : ""}`}>
        <div
          className="sidebar-toggle-btn icon"
          aria-label="Toggle Sidebar"
        ></div>
        <div className="collapsed-menu-item menu-item" onClick={handleSidebar}>
          <img
            className="sidebar-img ms-1"
            src={sidebarValue ? expandPanel : ClosePanel}
            alt="Comprimi"
          />
          {!sidebarValue && (
            <span className="collapsed-menu-label menu-label ms-3">
              Comprimi
            </span>
          )}
        </div>
        <div className="border-top" style={{ borderWidth: "1px" }}></div>
        <nav className={`${sidebarValue ? "wide" : "narrow"} side-scroll`}>
          <ul className="nav flex-column mb-6">
            {renderMenuItems(JSON.parse(sideMenuData))}
          </ul>
          <FooterComponent />
        </nav>
      </div>
    </div>
  );
};

export default SideMenu;
